export default "__VITE_ASSET__0a22cd0b__"